import React, { useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ClinicServiceRegularForm = (props) => {
  const { init_clinic_service } = props;
  const [currentRegular, setCurrentRegular] = useState(init_clinic_service);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeEnabled = () => {
    setCurrentRegular({
      ...currentRegular,
      enabled: !currentRegular.enabled,
    })
  }

  const onChangeData = (e) => {
    setCurrentRegular({
      ...currentRegular,
      [e.target.name]: e.target.value,
    })
  };

  const onClickClinicServiceRegularUpdate = () => {
    var data = {
      clinic_service: {
        enabled: currentRegular.enabled,
        base_price: parseInt(currentRegular.base_price, 10),
      },
      id: currentRegular.id,
    };

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.patch(`/api/v1/clinic_services/${currentRegular.id}`, data)
    .then(resp => {
      console.log("ClinicServiceRegular Update api ok");
      console.log(resp.data);
      notify("success", "ClinicServiceRegular Update Success!");
    })
    .catch(e => {
      console.log("ClinicServiceRegular Update api ng");
      console.log(e.response);
      setCurrentRegular({ 
        ...currentRegular,
        enabled: init_clinic_service.enabled,
        base_price: init_clinic_service.base_price,
      });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "ClinicServiceRegular Update Error!");
    });
  }

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header" id="panelsStayOpen-headingRegular">
          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseRegular" aria-expanded="true" aria-controls="panelsStayOpen-collapseRegular">
            定期健康診断
          </button>
        </h2>
        <div id="panelsStayOpen-collapseRegular" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingRegular">
          <div className="accordion-body">
            <div className="row">
              <div className="col mb-3">
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" id="flexSwitchCheckCheckedRegular" checked={currentRegular.enabled} onChange={onChangeEnabled} />
                  <label className="form-check-label" htmlFor="flexSwitchCheckCheckedRegular">定期健康診断可能</label>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col col-md-4 col-sm-12">
                <div className="input-group mb-3">
                  <span className="input-group-text" id="basic-base_price">料金</span>
                  <input type="number" name="base_price" className="form-control" id="basic-base_price" value={currentRegular.base_price || ''} onChange={onChangeData} />
                </div>
              </div>
            </div>

            <div className="d-grid gap-2 col-3 mx-auto">
              <button 
                className="btn btn-primary" 
                type="button"
                onClick={onClickClinicServiceRegularUpdate}
              >
                内容更新
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};